import { combineReducers } from 'redux'

import playlistReducer, { initialState as playlistState } from './playlist/reducers'
import systemReducer, { initialState as systemState } from './system/reducers'

export const initialState = 
    {
        playlist: playlistState,
        system: systemState
    }

export const rootReducer = combineReducers(
    {
        playlist: playlistReducer,
        system: systemReducer
    })

export type AppState = ReturnType<typeof rootReducer>